import { render, staticRenderFns } from "./listDrawer.vue?vue&type=template&id=d36d63fa&scoped=true&"
import script from "./listDrawer.vue?vue&type=script&lang=ts&"
export * from "./listDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./listDrawer.vue?vue&type=style&index=0&id=d36d63fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36d63fa",
  null
  
)

export default component.exports